import { render, staticRenderFns } from "./shipping-rates.vue?vue&type=template&id=59e3c536&"
import script from "./shipping-rates.vue?vue&type=script&lang=js&"
export * from "./shipping-rates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports